import styled from '@emotion/styled';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { createElement, FC, MouseEventHandler, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../../theme';
import { SPACING_UNIT } from '../../../constant/spacing';
import _KaizenPointIcon from '../../primitive/KaizenPointIcon';

type Props = {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  isNeedFee: boolean;
  className?: string;
};

const ModificationRequestSendingDialog: FC<Props> = ({
  onClickAcceptButton,
  onRequestClose,
  open,
  isNeedFee,
  className,
}) => {
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    // disabledのボタンを一定時間後に解除
    if (isButtonDisabled) {
      setTimeout(() => {
        setButtonDisabled(false);
      }, 1000);
    }
  }, [isButtonDisabled]);

  const handleOnAccept: MouseEventHandler<HTMLElement> = (e) => {
    // ボタン連打対策でボタンをdisabledに変更
    setButtonDisabled(true);
    onClickAcceptButton(e);
  };

  const dialogItems = isNeedFee ? (
    <div>
      <DialogTitle>
        <KaizenPointIcon color={theme.palette.primary.main} />
        <FormattedMessage id="modification_request_creating_card.request_for_a_fee_sending_dialog.title" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="modification_request_creating_card.request_for_a_fee_sending_dialog.description" />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onRequestClose} color="primary">
          <FormattedMessage id="modification_request_creating_card.request_for_a_fee_sending_dialog.decline" />
        </Button>

        <Button onClick={handleOnAccept} color="primary" autoFocus disabled={isButtonDisabled}>
          <FormattedMessage id="modification_request_creating_card.request_for_a_fee_sending_dialog.accept" />
        </Button>
      </DialogActions>
    </div>
  ) : (
    <div>
      <DialogTitle>
        <FormattedMessage id="modification_request_creating_card.request_for_a_no_fee_sending_dialog.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="modification_request_creating_card.request_for_a_no_fee_sending_dialog.description" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onRequestClose} variant="text">
          <FormattedMessage id="modification_request_creating_card.request_for_a_no_fee_sending_dialog.decline" />
        </Button>

        <Button onClick={handleOnAccept} variant="text" autoFocus disabled={isButtonDisabled}>
          <FormattedMessage id="modification_request_creating_card.request_for_a_no_fee_sending_dialog.accept" />
        </Button>
      </DialogActions>
    </div>
  );

  return (
    <Dialog open={!!open} onClose={onRequestClose} className={className}>
      {dialogItems}
    </Dialog>
  );
};

const KaizenPointIcon = styled(_KaizenPointIcon)({
  marginRight: SPACING_UNIT,
});

export default ModificationRequestSendingDialog;
